import { render, staticRenderFns } from "./trafficStock.vue?vue&type=template&id=daeb4b54&scoped=true"
import script from "./trafficStock.vue?vue&type=script&lang=js"
export * from "./trafficStock.vue?vue&type=script&lang=js"
import style0 from "./trafficStock.vue?vue&type=style&index=0&id=daeb4b54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daeb4b54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daeb4b54')) {
      api.createRecord('daeb4b54', component.options)
    } else {
      api.reload('daeb4b54', component.options)
    }
    module.hot.accept("./trafficStock.vue?vue&type=template&id=daeb4b54&scoped=true", function () {
      api.rerender('daeb4b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/trafficStock.vue"
export default component.exports